// extracted by mini-css-extract-plugin
module.exports = {"qualitySelector":"f2","label":"f3","downloadSize":"f4","selectorWrapper":"f5","selected":"f6"};